<template>

    <a v-if="p_fullLink_s" :href="p_link_s" target="_blank">
        <slot></slot>
    </a>

    <a v-else-if="p_openNewTab_b" :href="route_addLangToPath_s(p_link_s)" target="_blank">
        <slot></slot>
    </a>

    <router-link v-else :to="route_addLangToPath_s(p_link_s)" >
        <slot></slot>
    </router-link>

</template>

<script>
import {route_addLangToPath_s} from "@/router";

export default {
    name: "TqLink",
    props:{
        p_link_s:{
            require: true,
            type: String
        },
        p_openNewTab_b : {
            require: true,
            type: Boolean
        },
        p_fullLink_s : {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            route_addLangToPath_s: route_addLangToPath_s
        }
    }
}
</script>

<style scoped>
</style>